import React, { createContext, useContext, useState, ReactNode } from 'react';

type PropertyContextType = {
  selectedPropertyId: string | 'all';
  setSelectedPropertyId: (id: string | 'all') => void;
};

const PropertyContext = createContext<PropertyContextType | undefined>(undefined);

export function PropertyProvider({ children }: { children: ReactNode }) {
  const [selectedPropertyId, setSelectedPropertyId] = useState<string | 'all'>('all');

  return (
    <PropertyContext.Provider value={{ selectedPropertyId, setSelectedPropertyId }}>
      {children}
    </PropertyContext.Provider>
  );
}

export function usePropertyContext() {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error('usePropertyContext must be used within a PropertyProvider');
  }
  return context;
}
